var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queue-management"},[_c(_vm.currentComponent,{tag:"component",on:{"componentAction":function($event){return _vm.componentAction($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }